<template>
  <div class="table-area">
    <div class ="table-a">
      <table id="basic" class="table infotable" ref = subDetail>
        <tbody>
        <tr>
          <th>대우일렉트</th>
          <td colspan="7">
            <input class="input" type="text" v-model="form.pictureUrl" disabled>
<!--            <input class="input" type="file" @submit.prevent="btnImageUpload_Click">-->
            <input type="file" ref="file" @change="fileChangeEvent" @click="fileOnClick"/>
          </td>
          <th>직영점</th>
          <td colspan="7">
            <input class="input" type="text" v-model="form.pictureUrl" disabled>
            <!--            <input class="input" type="file" @submit.prevent="btnImageUpload_Click">-->
            <input type="file" ref="file" @change="fileChangeEvent" @click="fileOnClick"/>
          </td>
        </tr>

        </tbody>
      </table>
    </div>

<!--    <pwd-change ref="pwdChange"  :param="param" style="height: 70%; display: none; margin-left: 10px;"/>-->

  </div>
</template>

<script>
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import ModelJaego from "@/components/ModelJaego";
import _ from "lodash";
export default {
  name: "userInfo",
  components: {ButtonCellRenderer},
  props: ['userDetail' , 'parentNm'],
  data() {
    return {
      form: {
        addr1: "",
        addr2: "",
        asAgentId:"",
        asAgentNm: "",
        companyId: "",
        createDt: "",
        creatorId: "",
        ctiId: "",
        ctiPwd: "",
        ctiStation: "",
        ctiYn: "",
        deleteYn: "",
        deptId: "",
        description: "",
        dutyId: "",
        email: "",
        emailYn: "",
        enterDt: "",
        erpId: "",
        erpPwd: "",
        faxNo: "",
        groupUid: "",
        hpNo: "",
        juminNo: "",
        loginYn: "",
        pictureUrl: "",
        retireDt: "",
        telNo: "",
        updateDt: "",
        updatorId: "",
        useYn: "",
        userCd: "",
        userId: "",
        userNm: "",
        userPwd:"",
        zipCd: ""
      },
      // eslint-disable-next-line vue/no-dupe-keys
      parentNm: "",
    };
  },
  methods: {
    setuserInfo() {
      Object.assign(this.form, this.userDetail, this.parentNm);
    },
    btnImageUpload_Click() {
      console.log();
    //Alert(hddVirtualPath.Value);
    //this.form.pictureUrl = GetThumbnail(ResolveUrl(hddVirtualPath.Value), "80x85");
    //txtPICTURE_URL.Value = hddVirtualPath.Value;
    },
    GetThumbnail(url, thumbnailSuffix){
      return (url, thumbnailSuffix, "System.Image.Default");
    },
    fileOnClick() {

      console.log(this.$refs.file.files[0]);

    },
    fileChangeEvent() {
      this.file = this.$refs.file.files[0] || {
        name: undefined
      }

      this.fileLoaded = this.$refs.file.files[0] !== undefined

      //this.uploadFile();
    },
    PwdChange(){

      let vm = this

      this.$modal.open({component: PwdChange, parent: this, width: 800, props: {before:'before',after:'after'}})

    },
  },
  watch: {
    userDetail() {
      this.setuserInfo();
    }
  }
}

</script>

<style scoped>
.btn-change{
  border-radius: 4px;
  padding: 0 20px;
  font-size: 15px;
  height: 34px;
  font-family: 'NotoM';
  background: #646464;
  color: #fff;
}
</style>